import React from 'react';

interface Props {
    eraseMode: string;
    erase: (mode: OptionType) => void;
}

type OptionType = 'one' | 'all' | 'next';

const WorkerEventEraseForm = ({ erase, eraseMode }: Props) => {
    const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        if (value === 'one' || value === 'all' || value === 'next') {
            erase(value);
        }
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <div className="my-2 row">
                    <div className="col-12 my-2">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="one"
                                value="one"
                                checked={eraseMode === 'one'}
                                id="one"
                                onChange={handleCheckChange}
                            />
                            <label className="form-check-label" htmlFor="is_shiftwork">
                                Esta fecha
                            </label>
                        </div>
                    </div>
                    <div className="col-12 my-2">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="eraseMode"
                                value="next"
                                checked={eraseMode === 'next'}
                                id="next"
                                onChange={handleCheckChange}
                            />
                            <label className="form-check-label" htmlFor="next">
                                Esta fecha y las posteriores
                            </label>
                        </div>
                    </div>
                    <div className="col-12 my-2">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="eraseMode"
                                value="all"
                                checked={eraseMode === 'all'}
                                id="all"
                                onChange={handleCheckChange}
                            />
                            <label className="form-check-label" htmlFor="all">
                                Todas las fechas de la jornada
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WorkerEventEraseForm;
